document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(MotionPathPlugin);

  const introTl = gsap.timeline({
    defaults: { ease: "power2.out", duration: 1 },
  });

  introTl
    .from("#branding-logo", {
      opacity: 0,
      scale: 0.8,
      duration: 0.8,
    })
    .from(
      "#branding-landing h1",
      {
        opacity: 0,
        y: 40,
      },
      "-=0.4"
    ) // overlap for snappier timing
    .from(
      "#branding-landing p",
      {
        opacity: 0,
        y: 40,
      },
      "-=0.6"
    )
    .from(
      "#branding-landing-buttons",
      {
        opacity: 0,
        y: 30,
      },
      "-=0.6"
    );

  // Animate heading and paragraph inside #branding-case
  gsap.from(
    "#branding-case-content h2, #branding-case-content p, #branding-case-content iframe",
    {
      scrollTrigger: {
        trigger: "#branding-case",
        start: "top 70%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 64,
      duration: 0.96,
      ease: "power2.out",
      stagger: 0.32, // h2 then p
    }
  );

  // Animate USPs
  gsap.from("#branding-usps .branding-usp", {
    scrollTrigger: {
      trigger: "#branding-usps",
      start: "top 30%",
      toggleActions: "play none none none",
    },
    opacity: 0,
    y: 64,
    duration: 0.96,
    stagger: 0.32, // stagger each USP card
    ease: "power2.out",
  });

  // Animate heading and paragraph inside #branding-usps
  gsap.from("#branding-usps h2, #branding-usps p", {
    scrollTrigger: {
      trigger: "#branding-usps",
      start: "top 70%",
      toggleActions: "play none none none",
    },
    opacity: 0,
    y: 32,
    duration: 0.96,
    ease: "power2.out",
    stagger: 0.32, // h2 then p
  });

  gsap
    .timeline({
      scrollTrigger: {
        trigger: "#huisstijlen-slider",
        start: "top 50%", // when top of #huisstijlen-slider hits 50% of viewport height
        toggleActions: "play none none none", // play on enter, reset on leave
      },
    })
    .from("#huisstijlen-slider .blog-slider-top h2", {
      duration: 0.64,
      opacity: 0,
      y: 64,
      ease: "power2.out",
    })
    .from("#huisstijlen-slider .blog-slider-top p", {
      duration: 0.64,
      opacity: 0,
      y: 80,
      ease: "power2.out",
    })
    .from(
      "#huisstijlen-slider .blog-article-card:nth-child(-n+3)",
      {
        duration: 0.96,
        opacity: 0,
        y: 80,
        stagger: 0.3,
        ease: "power2.out",
      },
      "-=0.5"
    )
    .from(
      "#huisstijlen-slider .swiper-arrow",
      {
        duration: 0.64,
        opacity: 0,
        x: (i, el) => (el.classList.contains("swiper-arrow--next") ? 30 : -30),
        ease: "power2.out",
      },
      "-=0.6"
    );

  gsap.from("#branding-packages-container h2", {
    scrollTrigger: {
      trigger: "#branding-packages-container",
      start: "top 60%",
      toggleActions: "play none none none",
    },
    opacity: 0,
    y: 50,
    duration: 1,
    ease: "power2.out",
  });

  // Animate each branding package card
  gsap.from(".branding-package", {
    scrollTrigger: {
      trigger: "#branding-packages-container",
      start: "top 60%",
      toggleActions: "play none none none",
    },
    opacity: 0,
    y: 128,
    duration: 0.96,
    ease: "power2.out",
    stagger: 0.15,
  });

  // end GSAP animations
});
